<kt-subheader1
  *ngIf="!layout || layout === 'subheader-v1'"
  [fluid]="fluid"
  [clear]="clear"></kt-subheader1>
